import styled from 'styled-components'

import ReactGA from 'react-ga4'
import {Navigate} from 'react-router-dom'
import LeftBar from '../home/components/leftBar'
import Levantamento from './Levantamento'

const Page = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden !important;
`

export default function LevantamentoMercado() {
    // Sem VITE_LEVANTAMENTO_URL no build, o levantamento-service não existe no
    // ambiente: a rota redireciona (o item do menu também já não aparece).
    if (!import.meta.env.VITE_LEVANTAMENTO_URL) {
        return <Navigate to="/" replace />
    }

    ReactGA.send({
        hitType: 'pageview',
        page: '/levantamento-mercado',
        title: 'Levantamento de Mercado',
    })

    return (
        <Page>
            <LeftBar />
            <Levantamento />
        </Page>
    )
}
